<template>
  <div class="index">
    <template v-if="bottom_nav == 0">
      <div class="top-bg"></div>
      <div class="nav-list">
        <div class="nav-item" :class="nav == 0 ? 'active' : ''" @click="cehck_nav(0)">
          未认领
        </div>
        <div class="nav-item" :class="nav == 1 ? 'active' : ''" @click="cehck_nav(1)">
          已认领
        </div>
      </div>
    </template>
    <div v-else style="height:.3rem"></div>
    <div class="hope-list" >
      <div class="hope-item" v-for="(item, index) in list"  @click="goPage('/hope/info?id='+item.id)">
        <div class="hope-user">
          <div>
            <div class="user-name">{{item.nickname}}</div>
            <div class="user-date">{{item.add_time}}</div>
          </div>
          <div class="hope-status cancel" v-if="nav == 0">未认领</div>
          <div class="hope-status confirm" v-else>已认领</div>
        </div>
        <div class="hope-intro omit2">{{item.synopsis}}</div>
        <div class="hope-address">
          <div class="iconfont icon-dizhi"></div>
          <div>{{item.address}}</div>
        </div>
        <div class="info-btn">
          <div>查看详情</div>
          <div class="iconfont icon-xiangyou"></div>
        </div>
      </div>
    </div>
    <div style="height: 1.5rem;"></div>
    <div class="bottom-nav">
      <div class="nav-item" :class="bottom_nav == 0 ? 'active' : ''" @click="cehck_bottom_nav(0)">
        <img v-if="bottom_nav == 0" :src="`${require('@assets/images/dywfl/hb1-1.png')}`" alt="">
        <img v-else :src="`${require('@assets/images/dywfl/hb1-0.png')}`" alt="">
        <div class="nav-title">微心愿</div>
      </div>
	  <div class="nav-item"  @click="goPage('/intro')">
		<img  :src="`${require('@assets/images/dywfl/hb2-0.png')}`" alt="">
	    <div class="nav-title">项目介绍</div>
	  </div>
      <div class="nav-item" :class="bottom_nav == 1 ? 'active' : ''" @click="cehck_my_wish()">
        <img v-if="bottom_nav == 1" :src="`${require('@assets/images/dywfl/hb2-1.png')}`" alt="">
        <img v-else :src="`${require('@assets/images/dywfl/hb2-0.png')}`" alt="">
        <div class="nav-title">认领记录</div>
      </div>
    </div>
	<Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>

<script>
import Loading from "@components/Loading";
import {getWish,getMyWish} from "@api/public";
export default {
  name: "CateList",
  components: {
	Loading,
  },
  props: {},
  data: function () {
    return {
      nav: 0,
      bottom_nav: 0,
	  list:[],
	  loaded: false,
	  loading: false,
    };
  },
  watch: {

  },
  mounted: function () {
	this.getWish();
  },
  methods: {
	cehck_nav(e){
	   this.nav=e;
	   this.getWish();
	},
	cehck_bottom_nav(e){
		if(e==0){
			this.nav=0;
		}
		this.bottom_nav=e;
		this.getWish();
	},
	//获取列表
	getWish(){
		getWish({nav:this.nav}).then(res => {
		  this.list=res.data
		});
	},
	cehck_my_wish(){
		this.nav=1;
		this.bottom_nav=1;
		this.list=[];
		getMyWish().then(res => {
		  this.list=res.data
		}).catch(() => {
          this.$dialog.error(res.msg);
        });
	},
    goPage(url) {
      this.$router.push({ path: url });
    }
  },
};
</script>
<style lang="scss" scoped>
.index {
  min-height: 100vh;
  background-color: #fceeef;
}

.top-bg {
  margin: .2rem .2rem -1.44rem;
  border-radius: .3rem;
  background-image: linear-gradient(0deg, #E4446E, #F0CBBB);
  height: 2rem;
}

.nav-list {
  margin: 0 .2rem;
  display: flex;
  align-items: center;
  justify-content: center;

  .nav-item {
    width: 2.9rem;
    border-radius: .3rem .3rem 0 0;
    text-align: center;
    line-height: 1.15rem;
    font-size: .28rem;
    position: relative;
    color: #fff;

    &.active {
      background-color: #fff;
      color: #F64272;

      &::after {
        content: '';
        display: block;
        width: .7rem;
        height: .05rem;
        background-color: #F64272;
        position: absolute;
        left: 50%;
        bottom: .25rem;
        transform: translate(-50%, 0);
      }
    }
  }
}

.hope-list {
  margin: 0 .2rem;
}

.hope-item {
  background-color: #fff;
  border-radius: .3rem;
  padding: .4rem 0 0;

  &~& {
    margin-top: .3rem;
  }

  .hope-user {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 .6rem;

    .user-name {
      font-size: .26rem;
    }

    .user-date {
      font-size: .22rem;
      color: #999;
      margin-top: .05rem;
    }
  }

  .hope-status {
    width: 1.5rem;
    line-height: .5rem;
    border-radius: .5rem;
    font-size: .26rem;
    text-align: center;


    &.cancel {
      background-color: #EAEAEA;
    }

    &.confirm {
      background-color: #FCEAEF;
      color: #F64272;
    }
  }

  .hope-intro {
    padding: .25rem .6rem 0;
    font-size: .3rem;
  }

  .hope-address {
    display: flex;
    align-items: center;
    padding: .25rem .6rem 0;
    font-size: .26rem;

    .iconfont {
      color: #B3B3B3;
      font-size: .3rem;
      margin-right: .2rem;
    }
  }

  .info-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: .86rem;
    color: #777;
    line-height: 1;
    border-top: 1px solid #FFE2E7;
    margin-top: .25rem;

    .iconfont {
      font-size: .24rem;
      margin-left: .2rem;
    }
  }
}

.bottom-nav {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  box-shadow: 0 0 .1rem #FEE1E5;

  .nav-item {
    text-align: center;
    padding: .2rem 0;
    font-size: .24rem;
    line-height: 1;

    &.active {
      color: #F64272;
    }

    img {
      width: .45rem;
      height: .45rem;
      margin-bottom: .1rem;
    }

  }
}
</style>
